import "./polyfills";

import * as Blocks from "./themes/blocks";
import * as Pages from "./themes/pages";

/* Static Page */
import * as StaticScripts from "./themes/static";

/* Game Logic */
import BD_GAME_LOGIC from "@bd-core/game-logic";
//Blocks object
Object.keys(Blocks).forEach((key) => new Blocks[key]());

//Pages object
Object.keys(Pages).forEach((key) => Pages[key]());

//Static Scripts
Object.keys(StaticScripts).forEach((key) => StaticScripts[key]());

//Game logic initialize
BD_GAME_LOGIC.init();
